
































































import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";
import { USDT_ASSET } from "hfox/constants";

@Component
class CheckBalance extends Mixins(mixins.page) {
  token = "";

  loading = false;

  usdtSymbol = USDT_ASSET.symbol;

  get appbar(): any {
    return {
      title: this.$t("hfox.check-balance")
    };
  }

  get title() {
    return this.$t("hfox.check-balance") as string;
  }

  mounted() {
    this.requestAssetToken();
  }

  handleOpen() {
    const token = this.token;
    const url = `https://mixin.network/#/explorer?query=${token}&type=account-balance`;
    window.location.href = url;
  }

  async requestAssetToken() {
    this.loading = true;
    try {
      const res = await this.$api.hfox.getHfoxAssetsToken();
      this.token = res.token;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default CheckBalance;
